import { render, staticRenderFns } from "./SingleScopeQuarterlyEmission.vue?vue&type=template&id=1cd4fbee&scoped=true"
import script from "./SingleScopeQuarterlyEmission.vue?vue&type=script&lang=js"
export * from "./SingleScopeQuarterlyEmission.vue?vue&type=script&lang=js"
import style0 from "./SingleScopeQuarterlyEmission.vue?vue&type=style&index=0&id=1cd4fbee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd4fbee",
  null
  
)

export default component.exports